import { BusinessHoursBuilder } from '../call-center/lines/business-hours.builder';
var WidgetChatSettingsBuilder = /** @class */ (function () {
    function WidgetChatSettingsBuilder() {
        this.item = {
            chatContentSettings: {
                title: 'en title',
                subTitle: 'en description',
                subTitleEnabled: true,
                responseTimeMessage: 'response time message',
                responseTimeMessageEnabled: true,
                displayAvatarsEnabled: true,
                inputPlaceHolder: 'en input placeholder',
            },
            businessHours: new BusinessHoursBuilder().build(),
            duringBusinessHoursSettings: {
                greetingMessageEnabled: true,
                greetingMessage: 'en greeting msg',
                requestEmailEnabled: true,
                requestEmailMessage: 'en request email msg',
                thanksMessage: 'en thanks msg',
                requestEmailOptional: true,
            },
            outsideBusinessHoursSettings: {
                blockContact: {
                    addMessage: false,
                    chatBlockContactMode: 2,
                    message: 'en block message',
                    showBusinessHours: true,
                    subtitle: 'en block contact subtitle',
                    title: 'en block contact title',
                },
                contactForm: {
                    formFields: [],
                    submitTitle: 'en submititle',
                    responseTimeMessageEnabled: true,
                    responseTimeMessage: 'en response time',
                    submitSubtitle: 'en contactForm subtitle',
                    title: 'en contactForm title',
                },
                contactMode: 2,
                contactViaChat: {
                    greetingMessageEnabled: true,
                    greetingMessage: 'en greeting msg',
                    requestEmailEnabled: true,
                    requestEmailMessage: 'en request email',
                    thanksMessage: 'en thanks msg',
                    requestEmailOptional: true,
                    overrideResponseTimeMessageEnabled: true,
                    awayMessage: 'en away msg',
                }
            }
        };
    }
    WidgetChatSettingsBuilder.prototype.withBusinessHours = function (hours) {
        this.item.businessHours = hours;
        return this;
    };
    WidgetChatSettingsBuilder.prototype.withContent = function (content) {
        this.item.chatContentSettings = content;
        return this;
    };
    WidgetChatSettingsBuilder.prototype.withDuringHours = function (settings) {
        this.item.duringBusinessHoursSettings = settings;
        return this;
    };
    WidgetChatSettingsBuilder.prototype.withOutsideHours = function (settings) {
        this.item.outsideBusinessHoursSettings = settings;
        return this;
    };
    WidgetChatSettingsBuilder.prototype.withBlockContact = function (settings) {
        this.item.outsideBusinessHoursSettings.blockContact = settings;
        return this;
    };
    WidgetChatSettingsBuilder.prototype.withContactForm = function (settings) {
        this.item.outsideBusinessHoursSettings.contactForm = settings;
        return this;
    };
    WidgetChatSettingsBuilder.prototype.withContactFromChat = function (settings) {
        this.item.outsideBusinessHoursSettings.contactViaChat = settings;
        return this;
    };
    WidgetChatSettingsBuilder.prototype.withContactMode = function (mode) {
        this.item.outsideBusinessHoursSettings.contactMode = mode;
        return this;
    };
    WidgetChatSettingsBuilder.prototype.build = function () {
        return this.item;
    };
    return WidgetChatSettingsBuilder;
}());
export { WidgetChatSettingsBuilder };
//# sourceMappingURL=widget-chat-settings.builder.js.map